export default {
	why_edim(state) {
		return state.why_edim
	},
}
